import { Icon } from '../../widgets/icon';
import React from 'react';
import NoEcommerce from 'src/shared/icons/no-ecommerce.svg';
import Store from 'src/shared/icons/store-alt-solid.svg';
import CustomCatLogo from 'src/shared/svg/providers/customcat_list_marker.png';
import HP_PrintOSLogo from 'src/shared/svg/providers/HP_PrintOS.png';
import InvitionLogo from 'src/shared/svg/providers/invition_list_marker.png';
import PrintfulLogo from 'src/shared/svg/providers/printful_list_marker.png';
import theme from 'src/shared/theme';
import styled from 'styled-components';

export const salesChannelsLabels = (eCommerce: string, forOrdersPage?: boolean) => {
    switch (eCommerce) {
        case 'API':
            return 'API';
        case 'BIG_COMMERCE':
            return 'Big Commerce';
        case 'CODE_CANYON':
            return 'Code Canyon';
        case 'C_CLOUD':
            return 'C Cloud';
        case 'ETSY':
            return 'Etsy';
        case 'MAGENTO':
            return 'Magento';
        case 'NET_SUITE':
            return 'Net Suite';
        case 'NONE':
            return forOrdersPage ? 'Manual orders' : 'Manual created products';
        case 'OPEN_CART':
            return 'Open Cart';
        case 'PRESTA_SHOP':
            return 'Presta Shop';
        case 'SHOPWARE':
            return 'Shopware';
        case 'SHOPIFY':
            return 'Shopify';
        case 'WOO_COMMERCE':
            return 'Woo Commerce';
        case 'TEST':
            return 'Test';
        case 'WIX':
            return 'Wix';
        case 'AMAZON':
            return 'Amazon';
        default:
            return '';
    }
};

export const statusList = [
    {
        label: 'UNPUBLISHED',
        value: '0'
    },
    {
        label: 'PUBLISHED',
        value: '1'
    }
];

export const productProviderIconsList = {
    TEMPLATE: <NoEcommerce />,
    UNDEFINED: <NoEcommerce />,
    ZAKEKE: <Store />,
    CUSTOM_CAT: <img src={CustomCatLogo} />,
    INVITION: <img src={InvitionLogo} />,
    PRINTFUL: <img src={PrintfulLogo} />,
    PRINTFUL_DIRECT: <img src={PrintfulLogo} />,
    HP: <img src={HP_PrintOSLogo} />,
    VERSORI: <NoEcommerce />,
    CASA_DE_LAS_CARCASAS: <NoEcommerce />,
    FAVORITE_GIFT: <NoEcommerce />
};

export const productProviderNameList = {
    TEMPLATE: 'Product template',
    UNDEFINED: 'No ecommerce',
    ZAKEKE: 'Your Store',
    CUSTOM_CAT: 'Custom Cat',
    INVITION: 'Printeers',
    PRINTFUL: 'Printful',
    PRINTFUL_DIRECT: 'Printful',
    HP: 'HP',
    VERSORI: 'VERSORI',
    CASA_DE_LAS_CARCASAS: 'Casa de las Carcasas',
    FAVORITE_GIFT: 'Favorite Gift'
};

export const TableFilterButton = styled.button`
    display: inline-flex;
    gap: 5px;
    width: auto;
    padding: 9px;
    font-size: ${theme.app.component.button.fontSize};
    font-weight: ${theme.app.component.button.fontWeight};
    background-color: white;
    border: none;
    color: rgb(68, 90, 100);
    text-transform: unset;

    &:hover {
        background-color: #f6f8f9 !important;
        color: rgb(68, 90, 100) !important;
        border-radius: 4px;
        cursor: pointer;
    }

    &:focus,
    &:active {
        outline: none;
    }

    ${Icon} {
        width: 14px;
        height: 14px;
    }
`;
